import { render, staticRenderFns } from "./ItemChildAppInstall.vue?vue&type=template&id=12be15fe&"
import script from "./ItemChildAppInstall.vue?vue&type=script&lang=js&"
export * from "./ItemChildAppInstall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports